import { render, staticRenderFns } from "./DialogMessage.vue?vue&type=template&id=4aa78c46&scoped=true&"
import script from "./DialogMessage.vue?vue&type=script&lang=js&"
export * from "./DialogMessage.vue?vue&type=script&lang=js&"
import style0 from "./DialogMessage.vue?vue&type=style&index=0&id=4aa78c46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa78c46",
  null
  
)

export default component.exports